import { render, staticRenderFns } from "./ContactCompanies.vue?vue&type=template&id=359c1db1&scoped=true&"
import script from "./ContactCompanies.vue?vue&type=script&lang=ts&"
export * from "./ContactCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCompanies.vue?vue&type=style&index=0&id=359c1db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c1db1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
